import classNames from 'classnames';
import React from 'react';
import { IChatTextMessage } from '@enuan/chat__utils';
import { Text } from '../../message/content';
import { useMessageContext } from '../../message/message.context';
import { useBlockMessageClassNames } from 'src/hooks/core/messages.hooks';
import { Message } from '../../UI/Message/Message';
import type { IOptionalMessageProps } from '../../UI/Message/Message';

type TextMessageProps = { className?: string } & IOptionalMessageProps;

/**
 * Wraps plain text messages in the standard chat message chrome.
 *
 * The component is dedicated to regular text messages so HTML widget commands
 * can be routed through their own specialized message component.
 *
 * @param props - Optional message chrome props and root class name.
 * @param ref - Ref forwarded to the message article element.
 * @returns Standard text message layout.
 */
export const TextMessage = React.forwardRef<HTMLElement, TextMessageProps>(
	function TextMessage({ className: classNameProp, ...props }, ref) {
		const { message } = useMessageContext<IChatTextMessage>();
		const messageClassName = useBlockMessageClassNames();

		return (
			<Message
				{...props}
				ref={ref}
				message={message}
				className={classNames(classNameProp, messageClassName, 'message--text')}
			>
				<Text />
			</Message>
		);
	},
);
